import { createFileRoute, Link } from "@tanstack/react-router";
import { LoanCategoryPage } from "@/components/laneguide/LoanCategoryPage";

export const Route = createFileRoute("/snabblan")({
  head: () => ({
    meta: [
      { title: "Snabblån – Utbetalning samma dag | Svensk Låneguide" },
      { name: "description", content: "Jämför snabblån med utbetalning samma dag. Endast 1 UC och besked direkt online." },
      { property: "og:title", content: "Snabblån – Utbetalning samma dag" },
      { property: "og:description", content: "Snabblån med besked direkt online, utbetalning samma dag." },
      { property: "og:type", content: "website" },
    ],
  }),
  component: () => (
    <LoanCategoryPage
      page="snabblan"
      productLabel="Snabblån"
      headingBefore="Direkt utbetalning av"
      underlined="snabblån utan UC"
      headingAfter=""
      subtitle={
        <>
          <Link to="/nyhet/$slug" params={{ slug: "snabblan-utan-uc" }} className="text-primary underline underline-offset-2">Snabblån</Link> är lån med belopp mellan 1 000 – 200 000 kr och korta löptider. Med snabblån får du vanligtvis direkt utbetalning och pengarna på kontot inom 15 minuter, du kan ansöka om ett snabblån utan UC och låga grundkrav (t.ex. utan inkomst eller skulder hos Kronofogden) – perfekt för akuta utgifter.
        </>
      }
      featuredTitleTemplate={(m) => `Toppval för snabblån i ${m}`}
    />
  ),
});
